// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataListItemDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingMetadataStatus } from "./routing-metadata-status.enum.gen";
import { RoutingMetadataUsageGenShape } from "./routing-metadata-usage.gen";

export const RoutingMetadataListItemDtoGenShape = z.strictObject({
  adviceSetId: z.string(),
  adviceSetName: z.string(),
  status: z.enum(RoutingMetadataStatus),
  tenures: z.array(z.string()),
  taggingSkillVersionId: z.string().optional(),
  taggedAt: z.string().optional(),
  reviewDate: z.string().optional(),
  usage: RoutingMetadataUsageGenShape.optional(),
});
